<template>

  <footer class="p-4  sm:p-6 bg-primary flex items-center justify-center flex-col">
    <div class="flex flex-col md:flex-row items-center space-y-8 sm:space-y-0 md:space-x-36">
      <div class="shrink-0 flex  flex-col">
        <img src="~/assets/images/base/logos/logo-beige-alone.png" width="100" height="100" alt="logo BCS"/>
        <div class="mt-10  text-secondary tracking-widest">
          Parce que chaque détail compte.
        </div>
      </div>

      <div class="flex flex-col w-full lg:grid lg:grid-cols-2 gap-8 lg:gap-10 lg:space-x-8 pt-10 lg:pt-0">

        <div>
          <h2 class="mb-4 text-lg font-semibold text-bold text-secondary">Contactez-nous</h2>
          <ul class="text-secondary">
            <li class="mb-4">
              <div class="flex justify-start space-x-2 items-center">
                <div class="w-5 h-5">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                          d="M18.4 20.75H18.17C15.5788 20.4681 13.0893 19.5846 10.9 18.17C8.86618 16.8747 7.13938 15.1513 5.84 13.12C4.42216 10.925 3.53852 8.42823 3.26 5.83001C3.22816 5.52011 3.2596 5.20696 3.35243 4.90958C3.44525 4.6122 3.59752 4.33677 3.8 4.10001C3.99694 3.86008 4.24002 3.66211 4.51486 3.51782C4.78969 3.37354 5.09068 3.28587 5.4 3.26001H8C8.56312 3.26058 9.10747 3.46248 9.53476 3.82925C9.96205 4.19602 10.2441 4.70349 10.33 5.26001C10.425 5.97489 10.6028 6.67628 10.86 7.35001C11.0164 7.77339 11.0487 8.23264 10.9531 8.67375C10.8574 9.11485 10.6378 9.51947 10.32 9.84001L9.71 10.45C10.6704 11.9662 11.9587 13.2477 13.48 14.2L14.09 13.6C14.4105 13.2822 14.8152 13.0626 15.2563 12.9669C15.6974 12.8713 16.1566 12.9036 16.58 13.06C17.2545 13.3148 17.9556 13.4926 18.67 13.59C19.236 13.6751 19.7515 13.9638 20.1198 14.402C20.488 14.8403 20.6837 15.3978 20.67 15.97V18.37C20.67 18.9942 20.4227 19.593 19.9823 20.0353C19.5419 20.4776 18.9442 20.7274 18.32 20.73L18.4 20.75ZM8 4.75001H5.61C5.49265 4.75777 5.37809 4.78924 5.27325 4.84252C5.1684 4.8958 5.07545 4.96979 5 5.06001C4.92658 5.14452 4.871 5.24302 4.83663 5.34957C4.80226 5.45612 4.7898 5.56852 4.8 5.68001C5.04249 8.03679 5.83362 10.304 7.11 12.3C8.28664 14.1467 9.85332 15.7134 11.7 16.89C13.6973 18.1798 15.967 18.9878 18.33 19.25C18.4529 19.2569 18.5759 19.2383 18.6912 19.1953C18.8065 19.1522 18.9117 19.0857 19 19C19.1592 18.8368 19.2489 18.6181 19.25 18.39V16C19.2545 15.7896 19.1817 15.5848 19.0453 15.4244C18.9089 15.2641 18.7184 15.1593 18.51 15.13C17.6839 15.0189 16.8724 14.8177 16.09 14.53C15.9359 14.4724 15.7686 14.4596 15.6075 14.4933C15.4464 14.5269 15.2982 14.6055 15.18 14.72L14.18 15.72C14.0629 15.8342 13.912 15.9076 13.7499 15.9292C13.5877 15.9508 13.423 15.9195 13.28 15.84C11.1462 14.6342 9.37997 12.8715 8.17 10.74C8.08718 10.598 8.05402 10.4324 8.07575 10.2694C8.09748 10.1065 8.17286 9.95538 8.29 9.84001L9.29 8.84001C9.40468 8.72403 9.48357 8.57751 9.51726 8.41793C9.55095 8.25835 9.53802 8.09244 9.48 7.94001C9.19119 7.15799 8.98997 6.34637 8.88 5.52001C8.85519 5.30528 8.75133 5.10747 8.58865 4.96513C8.42597 4.82278 8.21613 4.7461 8 4.75001Z"
                          fill="#F3EDD6"></path>
                    </g>
                  </svg>
                </div>
                <div>
                  06 08 77 35 43
                </div>
              </div>
            </li>

            <li>
              <div class="flex justify-start space-x-2 items-center">
                <div class="w-5 h-5">
                  <svg fill="#F3EDD6" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                          d="M1920 428.266v1189.54l-464.16-580.146-88.203 70.585 468.679 585.904H83.684l468.679-585.904-88.202-70.585L0 1617.805V428.265l959.944 832.441L1920 428.266ZM1919.932 226v52.627l-959.943 832.44L.045 278.628V226h1919.887Z"
                          fill-rule="evenodd"></path>
                    </g>
                  </svg>
                </div>
                <div class="text-md">
                  contact@bienchezsoirenovation.fr
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <h2 class="mt-4 sm:mt-0 text-lg font-semibold text-secondary">Nos réseaux sociaux</h2>
          <div class=" flex space-x-6 sm:mt-6">

            <div v-for="network in social_network">

              <div class=" mt-4 space-x-2 sm:justify-center sm:mt-0">
                <NuxtLink :to="network.url" target="_blank">
                  <div class="w-7 h-7" :class="network.bg"></div>
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <hr class="my-8 border-secondary w-full lg:my-8"/>
    <div class="flex flex-col max-sm:gap-y-5 sm:flex-row sm:items-center sm:justify-between gap-x-8 space-x-6">
      <div class="flex justify-center gap-x-3 items-center">
        <div class="text-sm text-gray-500 sm:text-center">© {{ new Date().getFullYear() }} - Tous
          droits reservés.
        </div>
        <NuxtLink to="/mentions-legales" class="text-sm text-gray-500 sm:text-center">
          Mentions légales
        </NuxtLink>
      </div>

      <div class="flex items-center text-sm text-gray-500 justify-center">
        <span>Fait avec</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="ml-1 mr-1 w-5 h-5 text-red-700">
          <path fill="currentColor" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
        </svg>
        <span>par</span>
        <a target="_blank" href="https://faudel.portfaulya.engineer/" class="ml-1 text-secondary underline border-b-2 underline-offset-4">Faudel</a>
      </div>

    </div>
  </footer>

</template>

<script setup>
const social_network = [
  {
    url: 'https://www.linkedin.com/company/bien-chez-soi-renovation/',
    bg: "bg-[url('~/assets/images/base/social-networks/Linkedin.svg')]"
  },
  {
    url: 'https://www.instagram.com/bienchezsoi.renovation/',
    bg: "bg-[url('~/assets/images/base/social-networks/Instagram.svg')]"
  },
  {
    url: 'https://www.facebook.com/profile.php?id=100076033666784',
    bg: "bg-[url('~/assets/images/base/social-networks/Facebook.svg')]"
  },
  {
    url: 'https://www.tiktok.com/@bienchezsoi.renovation?lang=fr',
    bg: "bg-[url('~/assets/images/base/social-networks/Tiktok.svg')]"
  },
  {
    url: 'https://www.youtube.com/channel/UCdWyQUnPij4JUv89-lM7QIA',
    bg: "bg-[url('~/assets/images/base/social-networks/Youtube.svg')]"
  },
]
</script>